import { render, staticRenderFns } from "./CompatibilityTag.vue?vue&type=template&id=01297c8c"
import script from "./CompatibilityTag.vue?vue&type=script&lang=js"
export * from "./CompatibilityTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports